import { SocialLinks } from 'src/config/types';
import { DEFAULT_STRATEGY } from 'src/features/staking/stCELO/descriptors';

type ValidatorInfo = {
  logo: string;
  links: SocialLinks;
  communityContributor?: boolean;
};

export const VALIDATOR_GROUPS: Record<string, ValidatorInfo> = {
  [DEFAULT_STRATEGY.address]: {
    logo: '/logos/stCELO.png',
    links: {
      website: 'https://docs.stcelo.xyz',
    },
  },
  '0x89d5bd54C43dDd10905A030DE6Ff02EbB6c51654': {
    logo: '/logos/validators/polychain.jpg',
    links: {
      website: 'https://polychain.capital',
      twitter: 'https://twitter.com/polychain',
    },
  },
  '0x01b2b83fDf26aFC3Ca7062C35Bc68c8DdE56dB04': {
    logo: '/logos/validators/figment.jpg',
    links: {
      website: 'https://figment.io',
      twitter: 'https://twitter.com/Figment_io',
    },
  },
  '0x81383e7C8801B102f742f4F5a5faD06867212b05': {
    logo: '/logos/validators/deutche-telekom.jpg',
    links: {
      website: 'https://www.telekom.com',
      twitter: 'https://twitter.com/deutschetelekom',
    },
  },
  '0x4dA92da1afbf103F2B52DD29326e34C98cA1E78c': {
    logo: '/logos/validators/a16z.jpg',
    links: {
      website: 'https://a16z.com',
      twitter: 'https://twitter.com/a16z',
    },
  },
  '0xE09632da4dEAFb3DA2Cd6939F31c98607fCCdBC5': {
    logo: '/logos/validators/clabs.jpg',
    links: {
      website: 'https://clabs.co',
      twitter: 'https://twitter.com/clabs',
    },
    communityContributor: true,
  },
  '0xbf55dF76204f00AcF296F76cF4Aaf86A866a5eb0': {
    logo: '/logos/validators/manta.jpg',
    links: {
      twitter: 'https://twitter.com/mantalabs_',
    },
  },
  '0x35aE10F412503aBcf9275133613E8df7f56E72Be': {
    logo: '/logos/validators/anchorage.png',
    links: {
      website: 'https://www.anchorage.com',
      twitter: 'https://twitter.com/Anchorage',
    },
  },
  '0x7e11E85faA97652623929c9677E442e219cE0BbD': {
    logo: '/logos/validators/binance.jpg',
    links: {
      website: 'https://www.binance.com',
      twitter: 'https://twitter.com/binance',
    },
  },
  '0xDaDBd6Cfb29b054aDC9c4c2Ef0F21f0BBdb44871': {
    logo: '/logos/validators/bison-trails.jpg',
    links: {
      website: 'https://bisontrails.co',
      twitter: 'https://twitter.com/bisontrails',
    },
  },
  '0x21FB4411FA5828344c2788aB07D4cc12a12571b9': {
    logo: '/logos/validators/vibestudio-ventures.jpg',
    links: {
      website: 'https://vibestudio.ventures',
      twitter: 'https://twitter.com/vibestudio_',
    },
  },
  '0x7194DFE766a92308880A943fD70F31c8E7c50e66': {
    logo: '/logos/validators/chainlayer.jpg',
    links: {
      website: 'https://www.chainlayer.io',
      twitter: 'https://twitter.com/chainlayerio',
    },
  },
  '0x7C75B0B81A54359E9dCCDa9cb663ca2e3De6B710': {
    logo: '/logos/validators/wotrust.jpg',
    links: {
      website: 'https://wotrust.us',
      twitter: 'https://twitter.com/wotrust1',
    },
  },
  '0xCc4B2Bcbbc9639ef1E91F47acfD12Bd131525e79': {
    logo: '/logos/validators/blockdaemon.jpg',
    links: {
      website: 'https://www.blockdaemon.com',
      twitter: 'https://twitter.com/BlockdaemonHQ',
    },
  },
  '0x0861a61Bf679A30680510EcC238ee43B82C5e843': {
    logo: '/logos/validators/ledger.jpg',
    links: {
      website: 'https://www.ledger.com',
      twitter: 'https://twitter.com/ledger',
    },
  },
  '0xF83C93ea360B66DDCD532960304948B1c10786a1': {
    logo: '/logos/validators/dsrv.jpg',
    links: {
      website: 'https://www.dsrvlabs.com',
      twitter: 'https://twitter.com/dsrvlabs',
    },
  },
  '0x81cef0668e15639D0b101bdc3067699309D73BED': {
    logo: '/logos/validators/chorus-one.jpg',
    links: {
      website: 'https://chorus.one',
      twitter: 'https://twitter.com/chorusone',
    },
  },
  '0xB33e9e01E561a1Da60f7Cb42508500e571afb6Eb': {
    logo: '/logos/validators/validator-capital.jpg',
    links: {
      website: 'https://www.validator.capital',
      twitter: 'https://twitter.com/ValidatorCap',
    },
  },
  '0x8eB004daD9397B8f23E1279905c584920000756D': {
    logo: '/logos/validators/zanshin-dojo.jpg',
    links: {
      website: 'https://zanshindojo.org',
    },
  },
  '0x2fd49E97262D505Fd76BB6E0e06eC10e1fd54589': {
    logo: '/logos/validators/keyko.jpg',
    links: {
      website: 'https://www.keyko.io',
      twitter: 'https://twitter.com/keyko_io',
    },
  },
  '0x15Ed3f6b79F5Fb9Ef1D99D37314Dd626b3005F0b': {
    logo: '/logos/validators/ag.jpg',
    links: {
      website: 'https://validator.ag',
    },
  },
  '0xFaa0b40645Ee5E8D9AE38393e8cDF8e5baA71d13': {
    logo: '/logos/validators/staking-fund.jpg',
    links: {
      website: 'https://staking.fund',
      twitter: 'https://twitter.com/stakingfund',
    },
  },
  '0x067e453918f2c44D937b05a7eE9DBFB804C54ADd': {
    logo: '/logos/validators/usopp.jpg',
    links: {
      website: 'https://www.usopp.club',
    },
  },
  '0x3753096ad5e8E390C05324B9ca2B1856A3182B48': {
    logo: '/logos/validators/stake-dao.jpg',
    links: {
      website: 'https://www.stakedao.org',
      twitter: 'https://twitter.com/StakeDAOHQ',
    },
  },
  '0x481EAdE762d6D0b49580189B78709c9347b395bf': {
    logo: '/logos/validators/happy-celo.jpg',
    links: {
      website: 'https://www.happycelo.com',
      twitter: 'https://twitter.com/HappyCelo_com',
    },
  },
  '0x061E9958028dcAa66fd8B255AD95194203b6c4Da': {
    logo: '/logos/validators/easy2stake.jpg',
    links: {
      website: 'https://www.easy2stake.com',
      twitter: 'https://twitter.com/easy2stake',
    },
  },
  '0xD72Ed2e3db984bAC3bB351FE652200dE527eFfcf': {
    logo: '/logos/validators/chain-vibes.png',
    links: {
      website: 'https://chainvibes.com',
      twitter: 'https://twitter.com/chain_vibes',
    },
  },
  '0x580F29aB04b7ED4E5aA86584D38c9317d9CF0358': {
    logo: '/logos/validators/cypher-core.jpg',
    links: {
      website: 'https://cyphercore.io',
      twitter: 'https://twitter.com/cypher_core',
    },
  },
  '0x6CF4bB9ff947610944c6D8E0E5Ea26B1dEa73196': {
    logo: '/logos/validators/perfect-stake.jpg',
    links: {
      website: 'https://perfectstake.com',
      twitter: 'https://twitter.com/perfectstake',
    },
  },
  '0x8a12caB622B8093208931fA008D12D6Ba5AF47E4': {
    logo: '/logos/validators/td-labs.jpg',
    links: {
      website: 'https://staked.us',
      twitter: 'https://twitter.com/staked_us',
    },
  },
  '0x0d4f8cEA48cDaDEAe345431577a64983c0535B12': {
    logo: '/logos/validators/censusworks.jpg',
    links: {
      website: 'https://censusworks.com',
      twitter: 'https://twitter.com/censusworks',
    },
  },
  '0xb35Be22BccB0dB9dC62967dcF15fEB97C20f854e': {
    logo: '/logos/validators/stake-service.jpg',
    links: {
      website: 'https://stakeservice.com',
      twitter: 'https://twitter.com/stakeservice',
    },
  },
  '0x0339Df3FE4f5ccC864EAE8491E5c8AEc4611A631': {
    logo: '/logos/validators/tessellated.jpg',
    links: {
      website: 'https://tessellated.io',
      twitter: 'https://twitter.com/tessellated_io',
    },
  },
  '0xc8A81D473992c7c6D3F469A8263F24914625709d': {
    logo: '/logos/validators/moonli-me.jpg',
    links: {
      website: 'https://moonli.me',
      twitter: 'https://twitter.com/moonli_me',
    },
  },
  '0x81AE1C73A326325216E25ff1af9EA3871195036E': {
    logo: '/logos/validators/the-celo-group.jpg',
    links: {
      website: 'https://thecelo.group',
    },
  },
  '0x3DcF2ED8dC84a63FfD2bfDc3CDb2fA0B1aeAfE5c': {
    logo: '/logos/validators/stakecito.jpg',
    links: {
      twitter: 'https://twitter.com/stakecito',
    },
  },
  '0x3D451dd723797b3DE938C5B22412032B6452591A': {
    logo: '/logos/validators/projecttent.jpg',
    links: {
      website: 'https://projecttent.com',
      twitter: 'https://twitter.com/projecttent',
    },
  },
  '0x8493BD3De67AC341D4cC11531f96a1A2cdBf29aD': {
    logo: '/logos/validators/ryabina.jpg',
    links: {
      website: 'https://ryabina.io',
      twitter: 'https://twitter.com/Ryabinaio',
    },
  },
  '0xAcdf897493A6000dbe256791E8A2beCbb405FD4F': {
    logo: '/logos/validators/simply-staking.jpg',
    links: {
      website: 'https://simplystaking.com',
      twitter: 'https://twitter.com/SimplyStaking',
    },
  },
  '0x2AF540161Cbeb58FdC99b159c76E390598860510': {
    logo: '/logos/validators/zkvalidator.jpg',
    links: {
      website: 'https://zkvalidator.com',
      twitter: 'https://twitter.com/zkvalidator',
    },
  },
  '0xe92B7BA8497486e94bb59C51F595b590c4a5f894': {
    logo: '/logos/validators/stakely.jpg',
    links: {
      website: 'https://stakely.io',
      twitter: 'https://twitter.com/Stakely_io',
    },
  },
  '0x70FC0b021dFdBb9A106D1Ed8F35f59D3f23eCb7B': {
    logo: '/logos/validators/atalma-io.jpg',
    links: {
      twitter: 'https://twitter.com/atalma_io',
    },
  },
  '0xc24baeac0Fd189637112B7e33d22FfF2730aF993': {
    logo: '/logos/validators/plus-v.jpg',
    links: {
      website: 'https://plusv.io',
    },
  },
  '0x71dcC67baEECd9308e341359f70B782D9C3565b8': {
    logo: '/logos/validators/virtual-hive.jpg',
    links: {
      website: 'https://virtualhive.io',
      twitter: 'https://twitter.com/VirtualHiveio',
    },
  },
  '0x0f66619058BB9675f3d394FCc2cE236a29901571': {
    logo: '/logos/validators/making-cash.jpg',
    links: {
      website: 'https://making.cash',
      twitter: 'https://twitter.com/_makingcash_',
    },
  },
  '0xc64DF5Be250264bf2888591D87cdeB13BFADC501': {
    logo: '/logos/validators/kytzu.jpg',
    links: {
      website: 'https://kytzu.com',
    },
  },
  '0x614B7654ba0cC6000ABe526779911b70C1F7125A': {
    logo: '/logos/validators/huglester.jpg',
    links: {
      website: 'https://huglester.com',
    },
  },
  '0xE141831c2c1198d79B9Ff61cD97C3bAca7F071E0': {
    logo: '/logos/validators/swift-staking.jpg',
    links: {
      website: 'https://www.swiftstaking.com',
      twitter: 'https://twitter.com/swiftstaking',
    },
  },
  '0x8580dB53C3ebC56230662B771ceF2707E92Ef83A': {
    logo: '/logos/validators/goods-and-services.jpg',
    links: {
      website: 'https://www.goodsandservicesvalidation.xyz',
    },
  },
  '0x602B65795BCc64b2fb329AC004236E194f077158': {
    logo: '/logos/validators/ministry-of-blocks.jpg',
    links: {
      website: 'https://ministryofblocks.com',
    },
  },
  '0x07fa1874ad4655AD0C763a7876503509be11e29E': {
    logo: '/logos/validators/bi23.jpg',
    links: {
      twitter: 'https://twitter.com/bi23com',
    },
  },
  '0xb434FeB47D6154B4B4058DF5C9fCeD123dB9aBF6': {
    logo: '/logos/validators/atweb3.jpg',
    links: {
      website: 'https://atweb3.co',
      twitter: 'https://x.com/atweb3_gmbh',
    },
  },
  '0xD19FB36B7F433fe13820767ef6d0E26FDbaB68CC': {
    logo: '/logos/validators/hashkey.jpg',
    links: {
      website: 'https://www.hashkey.cloud',
      twitter: 'https://twitter.com/HashKeyCloud',
    },
  },
  '0xB87f2354E34B26ba6406Ac60EA99DCD8cd5e63Bf': {
    logo: '/logos/validators/tpt.jpg',
    links: {
      website: 'https://thepassivetrust.com',
      twitter: 'https://twitter.com/0xTPT',
    },
  },
  '0x82f8Bcf96f24BA60Ef041D192c7CE04C907E2fb8': {
    logo: '/logos/validators/sync-node.jpg',
    links: {
      twitter: 'https://twitter.com/syncn0de',
    },
  },
  '0x95aE59515915D6c493a846aE022F93726652b50A': {
    logo: '/logos/validators/master-node.jpg',
    links: {
      website: 'https://masternode24.de',
      twitter: 'https://twitter.com/masternode24',
    },
  },
  '0x34649AdA2cB44D851a2103Feaa8922DedDABfc1c': {
    logo: '/logos/validators/bitcandy.jpg',
    links: {
      website: 'https://example.com/bitcandy',
      twitter: 'https://twitter.com/getbitcandy',
    },
  },
  '0x8851F4852ce427191Dc8D9065d720619889e3260': {
    logo: '/logos/validators/moonlet.jpg',
    links: {
      website: 'https://moonlet.io',
      twitter: 'https://twitter.com/moonlet_wallet',
    },
  },
  '0xeE6c0fA803099837690D440B3108D03763ab7550': {
    logo: '/logos/validators/google-cloud.jpg',
    links: {
      website: 'https://cloud.google.com/web3',
      twitter: 'https://twitter.com/googlecloud',
    },
  },
  '0x0E912990472bfe5948B5b7333Ecf528D5dA887cF': {
    logo: '/logos/validators/tero-labs.jpg',
    links: {
      website: 'https://www.terolabs.org',
    },
  },
  '0xc764293De02189e248a8040a3D1b04EeC599Aa31': {
    logo: '/logos/validators/audit-one.jpg',
    links: {
      website: 'https://audit.one',
      twitter: 'https://twitter.com/AuditOne_',
    },
  },
  '0xE075ba4b1dCAF75513118d7aA08A057c658842c9': {
    logo: '/logos/validators/epv.png',
    links: {
      website: 'https://epv.lol',
    },
  },
  '0x26e6b535A62d2Ce81BC84DBFD836548A2fcb3104': {
    logo: '/logos/validators/01node.jpg',
    links: {
      website: 'https://01node.com',
      twitter: 'https://twitter.com/01node',
    },
  },
  '0x2c2B0f71d59B546B2CAfd222696589c13C3c325C': {
    logo: '/logos/validators/nodito.jpg',
    links: {
      website: 'https://noditolabs.com',
    },
  },
  '0x98c62d86634bB0E3f818EFC550e2F33369Eae7F3': {
    logo: '/logos/validators/tango.jpg',
    links: {
      twitter: 'https://twitter.com/tangovalidator',
    },
  },
  '0x6f8e6ff69935F000B09d182A4739342fAEaF0c77': {
    logo: '/logos/validators/coinlist.jpg',
    links: {
      website: 'https://coinlist.co',
      twitter: 'https://twitter.com/CoinList',
    },
  },
  '0x3C86b6A27a074c1c4CC904d8808A1C33078DB4E6': {
    logo: '/logos/validators/celo-works.jpg',
    links: {},
  },
  '0x249a6B2B260000b08f50A2480e2d703bAf02E8BE': {
    logo: '/logos/validators/chainflow.png',
    links: {
      website: 'https://chainflow.io',
      twitter: 'https://twitter.com/chainflowpos',
    },
  },
  '0xd8457a4b949c1b7Bc26538F54743Aa61EEcA38B6': {
    logo: '/logos/validators/grassroots.jpg',
    links: {
      website: 'https://twitter.com/grassEcon',
      twitter: 'https://twitter.com/grassrootsnetwork',
    },
    communityContributor: true,
  },
  '0x4D5A51039ea45063D4b665B21755db20A738DaDc': {
    logo: '/logos/validators/stakefish.jpg',
    links: {
      website: 'https://stake.fish',
      twitter: 'https://twitter.com/stakefish',
    },
  },
  '0x4b59D11Fee7ADAAB1ccBFeA0A48C3e91B2D92B23': {
    logo: '/logos/validators/telefonica.jpg',
    links: {
      website: 'https://www.telefonica.com',
      twitter: 'https://twitter.com/Telefonica',
    },
  },
  '0xC80AF7298642bE7eb156F51311D3C4A314688909': {
    logo: '/logos/validators/ethichub.png',
    links: {
      website: 'https://ethichub.com',
      twitter: 'https://x.com/ethichub',
    },
  },
  '0x6F769BcC21A867b839b6cA59dDe6c6C90c1DF18D': {
    logo: '/logos/validators/celo-pg.png',
    links: {
      website: 'https://www.celopg.eco/',
      twitter: 'https://x.com/CeloPublicGoods',
    },
    communityContributor: true,
  },
  '0xd42Bb7FE32cDf68045f49553c6f851fD2c58B6a9': {
    logo: '/logos/validators/celo-colombia.png',
    links: {
      website: 'https://www.celocolombia.org/',
      twitter: 'https://x.com/celo_col',
    },
  },
};
